import { t } from "@lingui/macro";

export const GPT_POST_EXTRA_FIELDS = [
  {
    id: "title",
    getDisplayName: () => t`Title`,
  },
  {
    id: "call_to_action",
    getDisplayName: () => t`Call to action`,
  },
] as const;
